import { createRoutes } from 'platform/forms-system/src/js/routing/createRoutes';
import formConfig from './config/form';
import App from './containers/App';
import IndexPage from './containers/IndexPage';

const routes = [
  {
    path: '/index',
    component: IndexPage,
  },
  {
    path: '/',
    component: App,
    indexRoute: {
      onEnter: (nextState, replace) => replace('/index'),
    },
    childRoutes: createRoutes(formConfig),
  },
];

export default routes;
